import { render } from "./SetPasswordModal.vue?vue&type=template&id=57c2546f&ts=true"
import script from "./SetPasswordModal.vue?vue&type=script&lang=ts"
export * from "./SetPasswordModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__